module.exports = __webpack_public_path__ + "assets/39d1407788635a53979bd36fc0608dc6.png";